export default function UsersSvg() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.83337 16.6665C5.83337 15.2858 7.69885 14.1665 10 14.1665C12.3012 14.1665 14.1667 15.2858 14.1667 16.6665"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 11.8745C16.4716 12.2603 17.5 13.1413 17.5 14.1665" stroke="white" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M5 11.8745C3.52841 12.2603 2.5 13.1413 2.5 14.1665" stroke="currentColor" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
                d="M10 11.6665C11.3807 11.6665 12.5 10.5472 12.5 9.1665C12.5 7.78579 11.3807 6.6665 10 6.6665C8.61929 6.6665 7.5 7.78579 7.5 9.1665C7.5 10.5472 8.61929 11.6665 10 11.6665Z"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M15 8.52993C15.5114 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.1089 4.40722 11.6666 4.80308"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M4.99996 8.52993C4.4885 8.07216 4.16663 7.40692 4.16663 6.6665C4.16663 5.28579 5.28591 4.1665 6.66663 4.1665C7.30692 4.1665 7.891 4.40722 8.33329 4.80308"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}
